import { Stack, Text } from '@eluve/components';

interface EmptyStateProps {
  message: string;
  centered?: boolean;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  message,
  centered = false,
}) => (
  <Stack
    className={centered ? 'flex-1 items-center justify-center' : 'px-3 py-4'}
    gap={2}
  >
    <Text size="xs" color="tertiary">
      {message}
    </Text>
  </Stack>
);
